module.exports = __webpack_public_path__ + "static/media/MigracióndeBasedeDatosaMongoDB.65ffa291.pdf";